import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

function useSnackbarAlert() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  function getMessage(msg:any) {
    const keys = ["resultMessage", "message", "resultDescription"];
    let defaultMsg = t("anErrorOccurred");

    keys.forEach((key) => {
      if (msg.hasOwnProperty(key)) {
        defaultMsg = msg[key];
      }
    });

    return defaultMsg;
  }

  function showSuccessMessage(message: any) {
    if (typeof message === "string") {
      enqueueSnackbar(message, { variant: "success" });
      return;
    }
    enqueueSnackbar(getMessage(message), { variant: "success" });
  }

  function showInfoMessage(message: any) {
    if (typeof message === "string") {
      enqueueSnackbar(message, { variant: "info" });
      return;
    }
    enqueueSnackbar(getMessage(message), { variant: "info" });
  }

  function showWarningMessage(message: any) {
    if (typeof message === "string") {
      enqueueSnackbar(message, { variant: "warning" });
      return;
    }
    enqueueSnackbar(getMessage(message), { variant: "warning" });
  }

  function showErrorMessage(message: any) {
    if (typeof message === "string") {
      enqueueSnackbar(message, { variant: "error" });
      return;
    }
    enqueueSnackbar(getMessage(message), { variant: "error" });
  }

  return { showSuccessMessage, showErrorMessage, showInfoMessage, showWarningMessage };
}

export default useSnackbarAlert;
